<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 500px;" class="detail">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" :disabled="true" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" :disabled="true" type="daterange" range-separator="至" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" :disabled="true" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;" class="detail">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <el-form-item label="消费维度" prop="consumptionDimension">
            <el-radio-group v-model="configForm.consumptionDimension" disabled>
              <el-radio label="1">电量</el-radio>
              <el-radio label="2">金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励标准" prop="rewardStandard">
            <div class="d-flex rewardStandard">
              <div>满</div>
              <el-input v-model="configForm.rewardStandard" disabled />
              <div>{{ configForm.consumptionDimension==='1'?'度':'元' }}</div>
            </div>
          </el-form-item>
          <template v-for="(row,index) in configForm.coupon">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="coupon">
              <div class="d-flex">
                <el-select v-model="row.couponId" disabled style="width: 200px;" placeholder="请选择优惠券">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" disabled class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                <div class="ml-20">张</div>
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
          <el-form-item label="可参与次数" prop="partakeNum">
            <el-input v-model="configForm.partakeNum" disabled placeholder="请输入当前活动用户可参与次数" />
          </el-form-item>
          <el-form-item label="活动电站" prop="powerStation">
            <el-radio-group v-model="configForm.powerStation" disabled>
              <el-radio v-for="(item, index) in activityPowerStation" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择运营商 -->
            <div v-show="configForm.powerStation==='2'" class="border">
              <!-- <el-input disabled v-model="filterOperatorText" placeholder="输入关键字进行过滤" /> -->
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="configForm.stationValue"
                :props="treeDefaultProps"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="configForm.powerStation==='3'" class="border">
              <!-- <el-input v-model="filterStationText" placeholder="输入关键字进行过滤" /> -->
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="configForm.stationValue"
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;" class="detail">
        <el-form ref="partakeForm" :model="partakeForm" :rules="partakeRules" label-width="100px">
          <el-form-item label="可参与用户" prop="partakeUser">
            <el-radio-group v-model="partakeForm.partakeUser" disabled>
              <el-radio v-for="(item, index) in partakeUserItem" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.partakeUser==='2'" class="border">
              <!-- <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" /> -->
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                :default-checked-keys="partakeForm.userValue"
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.partakeUser==='3'" class="border">
              <!-- <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" /> -->
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                :default-checked-keys="partakeForm.userValue"
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户参与记录</span>
      </div>
      <STable
        ref="detailTableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
import { HOST } from '@/utils/host'
import { treeDisabled } from '@/utils/tool'
export default {
  props: {
    // 表单信息数据
    // formData: {
    //   type: Object,
    //   default() {
    //     return {

    //     }
    //   }
    // },
    // // 预留的id，通过id查询详情信息
    // id: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: ''// 活动说明
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [
        {
          id: 0,
          label: '优惠券一'
        },
        {
          id: 1,
          label: '优惠券二'
        },
        {
          id: 2,
          label: '优惠券三'
        }
      ],
      // 活动电站
      activityPowerStation: [
        {
          label: '全部电站',
          id: '1'
        }, {
          label: '选择运营商',
          id: '2'
        }, {
          label: '选择电站',
          id: '3'
        }
      ],
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      configForm: {
        consumptionDimension: '1', // 消费维度
        rewardStandard: '', // 奖励标准
        coupon: [// 优惠券
          {
            couponId: '', // 优惠券类型
            count: ''// 优惠券数量
          }
        ],
        partakeNum: '', // 可参与次数
        powerStation: 0, // 活动电站单选框
        operator: [], // 选择运行商时的树数据
        station: []// 选择电站时的树数据
      },
      configRules: {
        consumptionDimension: [
          { required: true, message: '请选择消费维度', trigger: 'change' }
        ],
        rewardStandard: [
          { required: true, message: '请输入奖励标准', trigger: 'blur' }
        ],
        coupon: { required: true, trigger: 'change', validator: (rewardRules, value, cb) => {
          if (this.couponRule) {
            return cb(new Error(this.couponRule))
          }
          return cb
        } },
        partakeNum: [
          { required: true, message: '请输入可参与次数', trigger: 'blur' }
        ],
        powerStation: [
          { required: true, message: '请选择活动电站', trigger: 'change' }
        ]
      },
      // 可参与用户字段的单选数据
      partakeUserItem: [
        {
          label: '全部用户',
          id: '1'
        }, {
          label: '选择企业',
          id: '2'
        }, {
          label: '选择标签',
          id: '3'
        }
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        partakeUser: 0, // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: []// 选择标签
      },
      partakeRules: {
        partakeUser: [
          { required: true, message: '请选择可参与用户', trigger: 'change' }
        ]
      },
      url: '/activity/pageParticipation',
      columns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '消费金额/充电度数',
          prop: 'amount',
          template: (index, reocrd) => {
            if (this.configForm.consumptionDimension == '1') {
              return this.getFloat(reocrd.amount) + '度'
            } else {
              return this.getFixed2(reocrd.amount) + '元'
            }
          }
        },
        {
          label: '消费时间',
          prop: 'createTime'
        }
      ],
      query: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        }, {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        }, {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        }, {
          label: '消费时间',
          prop: 'timeRange',
          placeholder: '',
          type: 'date2'
        }, {
          label: '参与次数',
          prop: 'times',
          placeholder: '请输入参与次数'
        }
      ],
      toolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/activity/exportParticipation?activityId=' + this.id
            const data = this.$refs.detailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户参与记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {
    // 优惠券的动态校验
    couponRule() {
      const dataArray = this.configForm.coupon
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
      }
      return ''
    }
  },
  beforeMount() {
        this.id=this.$route.query.id
    this.url = '/activity/pageParticipation?activityId=' + this.id
  },
  mounted() {
      this.formData=JSON.parse(decodeURIComponent(this.$route.query.infoForm))
    // 接收数据后回显赋值
    this.$nextTick(() => {
      // 获取全部优惠券数据
      this.loadCoupon()
      // 页面数据转换接口
      this.getData()
      // 查询全部运营商方法
      this.getOperatorTree()
      // 查询全部电站方法
      this.getStationTree()
      // 查询全部企业方法
      this.getMechanismTree()
      // 查询全部标签方法
      this.getTagTree()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部运营商树的数据
    getOperatorTree() {
      const data = {
        treeDepth: 'ORG'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.operatorTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部电站树的数据
    getStationTree() {
      const data = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.stationTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 页面数据转换方法
    getData() {
      console.log('全部数据', this.allCoupon)
      this.ruleForm = JSON.parse(JSON.stringify(this.formData.ruleForm))
      this.configForm = JSON.parse(JSON.stringify(this.formData.configForm))
      this.partakeForm = JSON.parse(JSON.stringify(this.formData.partakeForm))
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      const val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      if (!val) return ''
      return val.stock || 0
    },
    back() {
      // this.$emit('backHome')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .detail{
    /deep/.el-input__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-textarea__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-input{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-separator{
      color: #606266 !important;
    }
    /deep/.el-range__icon{
      color: #606266 !important;
    }
  }
  .d-flex{
    display: flex;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .rewardStandard{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/singleDetail.vue